import type { LastCustomerOrder } from "@store/slices/magentoApiSlice/endpoints/getLastCustomerOrder.endpoint";

import type { MagentoApiGetLastCustomerOrderQueryResponse } from "@jti/magento-api-v2";

type RawLastCustomerOrder = MagentoApiGetLastCustomerOrderQueryResponse["LastCustomerOrder"];
type RawPaymentMethod = NonNullable<NonNullable<RawLastCustomerOrder>["payment_methods"]>[number];
type RawAttribute = NonNullable<RawLastCustomerOrder>["additional_attributes"][number];

type PaymentMethod = NonNullable<LastCustomerOrder>["payment_methods"][number];
type Attribute = NonNullable<LastCustomerOrder>["additional_attributes"][number];

const isValidPaymentMethod = (method: RawPaymentMethod | null): method is PaymentMethod =>
  Boolean(method?.type && method.method_code);

const isValidAttribute = (attr: RawAttribute | null): attr is Attribute => Boolean(attr?.attribute_code && attr.value);

export const normalizeLastCustomerOrder = (lastOrder: RawLastCustomerOrder | undefined): LastCustomerOrder => {
  if (!lastOrder) {
    return undefined;
  }

  return {
    __typename: "CustomerOrder",
    shipping_method_code: lastOrder.shipping_method_code ?? "",
    payment_methods: (lastOrder.payment_methods ?? []).filter(isValidPaymentMethod),
    additional_attributes: lastOrder.additional_attributes.filter(isValidAttribute),
  };
};
